import packDataService from "../../services/packsDataService";
import { type AppDispatch } from "../../../../Application/globaltypes/redux";
import { req, err, got } from "../slices/packFiltersSlice";

export const fetchPackFilters = () => async (dispatch: AppDispatch) => {
  dispatch(req());
  try {
    const res = await packDataService.getPackFiltersAsync();
    dispatch(got({ items: res.data }));
  } catch (e) {
    let errorMessage = (e as Error).message;
    dispatch(err(errorMessage));
  }
};
